import * as React from 'react'

const CusProgressBar = (props) => {
    const { bgcolor, completed } = props;

    const containerStyles = {
      // height: 15,
      backgroundColor: "#e0e0de",
      borderRadius: 50,
      marginTop: 15,
      marginBottom: 15
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'center'
    }
  
    const labelStyles = {
      color: 'white',
      fontSize: 10,
      fontWeight:'bold'
    }
  
    return (
      <div className="row around-xs inputPair elementVisible">
      <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <div style={labelStyles}>{`${completed}%`}</div>
        </div>
      </div>
      </div></div>
    );
  };
 

export default CusProgressBar;